import React from 'react';
import './yelp.scss';

// Official Yelp logo (public/img/gcm/yelp.svg); size it by height, width follows
export const YelpWordmark = ({ className = '' }) => (
    <img
        className={`gcm-yelp-mark ${className}`}
        src={`${process.env.PUBLIC_URL}/img/gcm/yelp.svg`}
        alt="Yelp"
    />
);

// Yelp's star colours by rating (their stars get warmer as the rating rises)
const starColor = (rating) => {
    if (rating >= 4.5) return '#fb433c';
    if (rating >= 4) return '#ff643d';
    if (rating >= 3.5) return '#ff7e42';
    if (rating >= 3) return '#ffad48';
    if (rating >= 2) return '#ffcc4b';
    return '#ffbe3c';
};

const STAR_PATH = 'M12 4.8l2.05 4.33 4.75.6-3.5 3.27.9 4.7L12 15.4l-4.2 2.3.9-4.7-3.5-3.27 4.75-.6z';

// Yelp-style rating: five rounded squares with a white star; each square is coloured by
// the share of the rating it covers (Yelp shows halves, so round to the nearest 0.5).
// `bracketed` renders the count as "(797) on yelp" (search results) instead of "797 on yelp".
// With `href` the rating links to the business's Yelp page (Yelp attribution), in a new tab.
export const YelpRating = ({ rating, reviewCount, bracketed = false, href, className = '' }) => {
    const rounded = Math.round(rating * 2) / 2;
    const color = starColor(rounded);
    const label = `${rating} out of 5 stars, ${reviewCount} reviews on Yelp`;
    const Root = href ? 'a' : 'div';
    const linkProps = href
        ? { href, target: '_blank', rel: 'noopener noreferrer', title: 'Read reviews on Yelp' }
        : {};
    return (
        <Root className={`gcm-rating ${href ? 'gcm-rating--link' : ''} ${className}`} aria-label={label} {...linkProps}>
            <span className="gcm-rating__stars" aria-hidden="true">
                {[0, 1, 2, 3, 4].map(i => {
                    const fill = Math.max(0, Math.min(1, rounded - i)) * 24;
                    return (
                        <svg key={i} className="gcm-rating__star" viewBox="0 0 24 24">
                            <rect width="24" height="24" rx="4" fill="#d7d7d7" />
                            {/* a nested <svg> clips to its width: the coloured part of the square */}
                            <svg width={fill} height="24" overflow="hidden">
                                <rect width="24" height="24" rx="4" fill={color} />
                            </svg>
                            <path d={STAR_PATH} fill="#fff" />
                        </svg>
                    );
                })}
            </span>
            <span className="gcm-rating__count">{bracketed ? `(${reviewCount})` : reviewCount} on</span>
            <YelpWordmark />
        </Root>
    );
};
